
document.addEventListener("DOMContentLoaded", () => {
    let rawStr = document.querySelector('#all_stores').value
    const cleaned = rawStr.endsWith(',') ? rawStr.slice(0, -1) : rawStr;
    let all_stores = JSON.parse("["+cleaned+"]")

    checkZipCode(all_stores);
});
const InHome = document.getElementById("custentity43");
const Virtual = document.getElementById("custentity44");
const InStore = document.getElementById("custentity45");

function checkZipCode(all_stores) {
    const zipCodeInput = document.querySelector(".newForm_2col > #zipInput");
    const divOption1 = document.getElementById("checkOptions1");
    const divOption2 = document.getElementById("checkOptions2");
    const divOption3 = document.getElementById("checkOptions3");
    const resetViz = document.getElementById("reset-consult");
    const infoText = document.querySelector(".typeText")

    zipCodeInput.addEventListener("change", function (event) {
        // console.log("zipcode change", zipCodeInput.value);
        const inputValue = event.target.value;
        if (inputValue.length === 5 && /^\d+$/.test(inputValue)) {
            getUserLatLon(inputValue)
                .then((result) => {
                const uLatt = result.latitude;
                const uLonn = result.longitude;
                let matchingInStores = [];
                all_stores.forEach((store) => {
                    let distance = calculateDistance(
                    uLatt,
                    uLonn,
                    store.lat,
                    store.lon,
                    );
                    if (distance < 50) {
                    store.distanceFromUser = distance;
                    matchingInStores.push(store);
                    }
                });
                if (matchingInStores.length === 0) {
                    divOption1.style.display = "none";
                    divOption2.style.display = "none";
                } else {
                    divOption2.style.display = "flex";
                    divOption1.style.display = "flex";
                }
                divOption3.style.visibility = "visible";
                resetViz.style.display = "flex";
                infoText.style.display = 'none';
                })
                .catch((error) => {
                console.log(error);
                });
            } else {
                infoText.style.display = 'flex';
                divOption1.style.display = "none";
                divOption2.style.display = "none";
                divOption3.style.visibility = "hidden";
                resetViz.style.display = "none";
            }
    });
}

function updateConsult(selectedValue) {
  if (selectedValue === "home") {
    InHome.value = "T";
    Virtual.value = "";
    InStore.value = "";
  } else if (selectedValue === "virtual") {
    Virtual.value = "T";
    InHome.value = "";
    InStore.value = "";
  } else if (selectedValue === "store") {
    InStore.value = "T";
    Virtual.value = "";
    InHome.value = "";
  } else {
    InStore.value = "";
    Virtual.value = "";
    InHome.value = "";
  }
}
function clearRadios() {
  const divElem = document.getElementById("consultQuestion");
  const radioButts = divElem.querySelectorAll('input[type="radio"]');
  radioButts.forEach((radioButt) => {
    radioButt.checked = false;
    Virtual.value = "";
    InHome.value = "";
    InStore.value = "";
  });
}
const clearElement = document.querySelector("#reset-consult");
if (clearElement) {
  clearElement.addEventListener("click", (event) => {
    event.preventDefault();
    clearRadios();
    // toggleSubmitButtonVisibility();
  });
}

/**
 *
 * address lines to appear when the in-home is selected
 *
 */
let hiddenDiv = document.querySelector(".streetAddressFields");
let hiddenAddressDiv = document.querySelector("input[name='address1']");
let homeSelected = document.querySelector(
    'input[title="Preferred In-home consultation"]',
);
let firstAddressInput = document.querySelectorAll('#addressInput')

let otherRadioButtons = document.querySelectorAll(".ynRadios");
otherRadioButtons.forEach((radioButton) => {
    radioButton.addEventListener("change", () => {
        if (homeSelected.checked) {
            hiddenDiv.style.display = "flex";
            // console.log(firstAddressInput)
            if(firstAddressInput.length == 0){
                hiddenAddressDiv.style = "flex"
            }
        } else {
            hiddenDiv.style.display = "none";
        }
    });
});

function getUserLatLon(zipcode) {
    const apiKey = "AIzaSyAZJfBF2JJUcJUiTj-CebLOz2xGpGBmEs4";
    const zipCode = zipcode;
    // console.log(zipcode);
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;

    return new Promise((resolve, reject) => {
        fetch(geocodeUrl)
        .then((response) => response.json())
        .then((data) => {
            if (data.results && data.results.length > 0) {
            const location = data.results[0].geometry.location;
            const latitude = location.lat;
            const longitude = location.lng;
            resolve({ latitude, longitude });
            } else {
            reject("No results found for the provided zip code.");
            }
        })
        .catch((error) => {
            reject(`Error fetching data from the Geocoding API: ${error}`);
        });
    });
}
function calculateDistance(lat1, lon1, lat2, lon2) {
  const radlat1 = (Math.PI * lat1) / 180;
  const radlat2 = (Math.PI * lat2) / 180;
  const radlon1 = (Math.PI * lon1) / 180;
  const radlon2 = (Math.PI * lon2) / 180;
  const theta = lon1 - lon2;
  const radtheta = (Math.PI * theta) / 180;
  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515; // Miles
  return dist;
}